import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useGetCrmBankingDocumentsByIdQuery } from "features/onboarding/users/farmer/farmerApiSlice";
import Lightbox from "react-awesome-lightbox";
import { Spinner, Table } from "react-bootstrap";
import "react-awesome-lightbox/build/style.css";
import { store } from "app/store";
import axios from "axios";
import { API_URL } from "app/config";
import { useAssignPolicyDetailsMutation } from "features/CrmDashboardComp/CmrApiSlice";
import { toast } from "react-toastify";
import { useUploadInsuranceFarmerDocsMutation } from "features/Insurance/InsuranceApiSlice";
import Swal from "sweetalert2";
import { TextField } from "@mui/material";

export const InsuranceDetailViewModal = ({
  serviceDetails,
  LeadsDataHalf,
  selectedProduct,
  refetchApplication,
  refetch,
  setDetailsModal,
}) => {
  const [openLightbox, setOpenLightBox] = useState(false);
  const [lightBoxViewImage, setImageInLightbox] = useState("");
  const [mediaType, setMediaType] = useState("");
  const [overlayUrl, setOverlayUrl] = useState("");
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [assignLeads] = useAssignPolicyDetailsMutation();
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [multipleDownloadFarmers] = useUploadInsuranceFarmerDocsMutation();
  const [zipDownload, setZipDownload] = useState(false);
  const id = LeadsDataHalf?.user_id;
  const { data: documents } = useGetCrmBankingDocumentsByIdQuery(id, {
    skip: !id,
  });

  const [cattleDocuments, setCattleDocuments] = useState([]);
  const [issueLoading, setIssueLoading] = useState({});
  const [remarks, setRemarks] = useState("");
  const [showPolicy, setShowPolicy] = useState(false);
  const [policyDetails, setPolicyDetails] = useState({
    policy_id: "",
    policy_url: "",
    file: null,
  });
  const [proposalLoadin, setProposalFormLoading] = useState(false);

  const [policyUrlError, setPolicyUrlError] = useState("");
  const [policyIssueRej, setPolicyIssRej] = useState("Policy Issued");
  const toggleDropdownStatus = () => setStatusChange(!statusChange);
  const [statusChange, setStatusChange] = useState(false);
  const validatePolicyUrl = (url) => {
    if (!url) return "Policy URL is required";
    if (!/^https?:\/\/.+/i.test(url)) return "Enter a valid URL";
    if (!url.toLowerCase().endsWith(".pdf")) return "URL must end with .pdf";
    return "";
  };

  useEffect(() => {
    if (serviceDetails?.cattle_data && documents?.data) {
      const allDocs = documents.data.flatMap((category) =>
        (category.document_types || []).flatMap((type) => type.documents || [])
      );

      const matchedDocs = serviceDetails.cattle_data.map((cattle) => ({
        ...cattle,
        documents: allDocs.filter(
          (doc) =>
            doc?.entity_id?.toLowerCase() ===
            cattle?.cattle_tag_number?.toLowerCase() +
              "_" +
              cattle?.cattle_id?.toLowerCase()
        ),
      }));

      setCattleDocuments(matchedDocs);
    }
  }, [serviceDetails, documents]);

  const refetchPreAssigned = async (path, type) => {
    const state = store.getState();
    try {
      const pathImageCattle = await axios.get(
        `${API_URL}/api/v1/onboarding/media/get_file?path=${path}`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!pathImageCattle?.data?.data?.url) return;
      const url = pathImageCattle?.data?.data?.url;
      if (type === "image") {
        setImageInLightbox(url);
        setOpenLightBox(true);
      } else if (type === "pdf") {
        openInNewTab(url);
      } else if (type === "mp4") {
        setOverlayUrl(url);
        setOverlayOpen(true);
      }
    } catch (error) {
      console.error("Error fetching farmer data:", error);
      throw error;
    }
  };
  const refetchPreAssignedPolicy = async (path, type) => {
    const state = store.getState();
    try {
      const pathImagePolicy = await axios.get(
        `${API_URL}/api/v1/crm/leads/media/get_file?path=${path}`,

        {
          headers: {
            Authorization: `Bearer ${state.auth.accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!pathImagePolicy?.data?.data?.url) return;
      const url = pathImagePolicy.data.data?.url;
      if (type === "image") {
        setImageInLightbox(url);
        setOpenLightBox(true);
      } else if (type === "pdf") {
        setOpenLightBox(false);
        openInNewTab(url);
      } else if (type === "mp4") {
        setOverlayUrl(url);
        setOverlayOpen(true);
        setOpenLightBox(false);
      }
    } catch (error) {
      console.error("Error fetching farmer data:", error);
      throw error;
    }
  };

  const convertToTitleCase = (text) => {
    if (!text) return "";
    return String(text)
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0)?.toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getTypeFromPath = (p) => {
    if (!p) return "image";
    const lower = p.toLowerCase();
    if (lower.endsWith(".pdf")) return "pdf";
    if (lower.endsWith(".mp4")) return "mp4";
    if (/\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(lower)) return "image";
    return "image";
  };

  // const openInNewTab = (url) => {
  //   window.open(url, "_blank", "noopener,noreferrer");
  //   let a = document.createElement("a")
  //   a.type = "application/pdf"
  //   a.target = "_blank"
  //   a.href =url
  //   a.click()
  // };
  const openInNewTab = async (URL) => {
    const res = await fetch(URL);
    const uint8arr = new Uint8Array(await new Response(res.body).arrayBuffer());

    const link = document.createElement("a");
    const blob = new Blob([uint8arr], { type: "application/pdf" });

    link.target = "_blank";
    link.href = window.URL.createObjectURL(blob);
    link.click();
  };

  const handleDocClick = (doc) => {
    if (!doc?.path) return;
    const type = getTypeFromPath(doc.path);
    setMediaType(type);
    refetchPreAssigned(doc.path, type);
  };

  const handlePolicyClick = async (policyPath) => {
    if (!policyPath) return;
    const type = getTypeFromPath(policyPath);
    setMediaType(type);
    refetchPreAssignedPolicy(policyPath, type);
  };

  const renderServiceDetailsGrid = () => {
    if (!serviceDetails || Object.keys(serviceDetails).length === 0)
      return null;
    return (
      <div className="row">
        {Object.keys(serviceDetails).map((key, index) => (
          <Col key={index} md="3">
            <div className="mt-3">
              <div style={{ color: "rgb(106 106 106)" }}>
                {convertToTitleCase(key)}:
              </div>
              <div className="mt-1" style={{ color: "#333" }}>
                {String(serviceDetails[key] ?? "-")}
              </div>
            </div>
          </Col>
        ))}
      </div>
    );
  };
  const handleInitiatePayment = (type) => {
    if (type === "Initiate Payment") setPaymentLoading(true);
    else setProposalFormLoading(true);
    let payload = new FormData();
    const leadIdArray = [LeadsDataHalf.id];
    payload.append("lead_id_list", JSON.stringify(leadIdArray));
    payload.append(
      "current_remarks",
      type === "Initiate Payment"
        ? "Initiate Payment"
        : "Proposal Form Submitted"
    );
    payload.append(
      "current_status",
      type === "Initiate Payment"
        ? "Initiate Payment"
        : "Proposal Form Submitted"
    );
    assignLeads(payload)
      .unwrap()
      .then(() => {
        toast.success("Updated Successfully!");
        setPaymentLoading(false);
        setProposalFormLoading(false);
        refetchApplication(LeadsDataHalf.id);
        refetch();
        setDetailsModal(false);
      })
      .catch(() => {
        toast.error("Error while Updating Leads. Try again later!");
        setPaymentLoading(false);
        setProposalFormLoading(false);
      });
  };

  const handleZipDownload = () => {
    setZipDownload(true);
    const leadIdArray = [LeadsDataHalf.user_id];
    const responseData = {
      farmer_id_list: leadIdArray,
      zip_file_name: "Leads",
    };
    multipleDownloadFarmers(responseData)
      .unwrap()
      .then((data) => {
        if (data?.data) {
          toast.success("Downloaded Successfully !!");
          window.open(data?.data, "_blank", "noopener,noreferrer");
          setZipDownload(false);
        }
      })
      .catch((error) => {
        toast.error("Error while Creating Task");
        setZipDownload(false);

        return;
      });
  };
  const [policyForms, setPolicyForms] = useState({}); // track which cattle has policy form open

  const togglePolicyForm = (cattleId) => {
    setPolicyForms((prev) => ({
      ...prev,
      [cattleId]: prev[cattleId]
        ? false // Close if already open
        : {
            action: "Issued", // default action
            policy_id: "",
            policy_url: "",
            policy_file: null,
            remarks: "",
          },
    }));
  };

  const handlePolicyChange = (cattleId, field, value) => {
    setPolicyForms((prev) => {
      const existing = prev[cattleId] || {};
      const updated = {
        ...existing,
        [field]: value,
      };

      if (field === "policy_url" && value) updated.policy_file = null;
      if (field === "policy_file" && value) updated.policy_url = "";

      return {
        ...prev,
        [cattleId]: updated,
      };
    });
  };

  const submitPolicy = (cattleId) => {
    const form = policyForms[cattleId];
    if (!form) return;
    if (form.action === "Issued") {
      if (
        !form.policy_id ||
        !form.remarks ||
        (!form.policy_url && !form.policy_file)
      ) {
        Swal.fire({
          title: "Enter Details",
          text: "Please provide valid details.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Continue",
          cancelButtonText: "Cancel",
          confirmButtonIcon: "fas fa-arrow-right",
        });
        return;
      }

      if (form.policy_url) {
        const urlPattern = new RegExp(
          "^(https?:\\/\\/)?" +
            "((([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)+[a-zA-Z]{2,}|" +
            "((\\d{1,3}\\.){3}\\d{1,3}))" +
            "(\\:\\d+)?(\\/[-a-zA-Z\\d%_.~+]*)*" +
            "(\\?[;&a-zA-Z\\d%_.~+=-]*)?" +
            "(\\#[-a-zA-Z\\d_]*)?$",
          "i"
        );

        if (!urlPattern.test(form.policy_url)) {
          alert("Please enter a valid Policy URL");
          return;
        }
      }
    }
    setIssueLoading((prev) => ({ ...prev, [cattleId]: true }));

    let payload = new FormData();
    const leadId = [LeadsDataHalf?.id];
    payload.append("lead_id_list", JSON.stringify(leadId));
    payload.append("cattle_id", cattleId);
    if (form.action === "Issued") {
      payload.append("current_status", "Policy Issued");
      payload.append("current_remarks", form.remarks || "");
      payload.append("policy_id", form.policy_id || "");
      if (form.policy_file) {
        payload.append("policy_document", form.policy_file);
      } else if (form.policy_url) {
        payload.append("policy_url", form.policy_url);
      }
    } else if (form.action === "Rejected") {
      payload.append("current_status", "Policy Rejected");
      payload.append("current_remarks", form.remarks || "");
    }
    assignLeads(payload)
      .unwrap()
      .then((res) => {
        toast.success(`Policy ${form.action} Successfully!`);
        setPolicyForms((prev) => ({ ...prev, [cattleId]: false }));
        setIssueLoading((prev) => ({ ...prev, [cattleId]: false }));
        try {
          refetchApplication(LeadsDataHalf.id);
          refetch();
        } catch (err) {
          console.error("Error inside then:", err);
        }
      })
      .catch((err) => {
        toast.error("Error while Issuing Policy. Try again later!");
        setIssueLoading((prev) => ({ ...prev, [cattleId]: false }));
      });
  };
  const handleFarmerPolicyIssue = () => {
    setShowPolicy(!showPolicy);
  };
  const handleAssign = (e) => {
    e.preventDefault();
    if (policyIssueRej === "Policy Issued") {
      if (!policyDetails.policy_url && !policyDetails.file) {
        Swal.fire({
          title: "Enter Details",
          text: "Please provide either a Policy URL or upload a document.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Continue",
          cancelButtonText: "Cancel",
          confirmButtonIcon: "fas fa-arrow-right",
        });
        return;
      }
      if (policyDetails.policy_url && policyDetails.file) {
        Swal.fire({
          title: "Enter Details",
          text:
            "You can only provide either a Policy URL or a document, not both.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Continue",
          cancelButtonText: "Cancel",
          confirmButtonIcon: "fas fa-arrow-right",
        });
        return;
      }
    }

    let payload = new FormData();

    const leadIdArray = [LeadsDataHalf.id];
    payload.append("lead_id_list", JSON.stringify(leadIdArray));

    payload.append("current_remarks", remarks);
    payload.append("current_status", policyIssueRej);
    // payload.append("policy_id", policyDetails.policy_id);

    // if (policyDetails.file === null)
    //   payload.append("policy_url", policyDetails.policy_url);
    // if (policyDetails.policy_url === "")
    //   payload.append("policy_document", policyDetails.file);

    if (policyIssueRej === "Policy Issued") {
      payload.append("policy_id", policyDetails.policy_id);
    }
    if (policyIssueRej === "Policy Issued" && policyDetails.file === null)
      payload.append("policy_url", policyDetails.policy_url);
    if (policyIssueRej === "Policy Issued" && policyDetails.policy_url === "")
      payload.append("policy_document", policyDetails.file);

    assignLeads(payload)
      .unwrap()
      .then(() => {
        toast.success(`${policyIssueRej} Successfully!`);
        refetchApplication(LeadsDataHalf.id);

        setRemarks("");
        setPolicyDetails({ policy_id: "", policy_url: "", file: null });
        refetch();
        setShowPolicy(false);
      })
      .catch(() => toast.error("Error while Issuing Policy. Try again later!"));
  };
  return (
    <>
      <Row>
        <Col md={12} lg={12}>
          <div
            style={{
              borderRadius: 10,
              padding: 24,
              boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
              marginBottom: 24,
              backgroundColor: "white",
              border: "1px solid #f0f0f0",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingBottom: 10,
              }}
            >
              {console.log("selectedProduct",selectedProduct)}
              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <h6 style={{ fontWeight: 600, margin: 0 }}>
                  APPLICANT DETAILS
                </h6>
              </div>
              {selectedProduct?.toLowerCase() === "cattle" &&
              <div style={{ display: "flex" }}>
                {!LeadsDataHalf?.status_list?.includes(
                  "Proposal Form Submitted"
                ) &&
                  !LeadsDataHalf?.status_list?.includes("Policy Issued") &&
                  !LeadsDataHalf?.status_list?.includes("Policy Rejected") && (
                    <Button
                      id="AddLeads"
                       style={{ backgroundColor: "#43b620",borderRadius: "8px"}}
                      className="mx-3"
                      size="sm"
                      onClick={() => handleInitiatePayment("Proposal Form")}
                    >
                      Submit Proposal Form&nbsp;
                      {proposalLoadin && <Spinner size="sm" />}
                    </Button>
                   )} 
                    {!LeadsDataHalf?.status_list?.includes(
                      "Payment Submitted"
                    ) &&
                      !LeadsDataHalf?.status_list?.includes(
                        "Initiate Payment"
                      ) && !LeadsDataHalf?.status_list?.includes("Policy Issued") &&
                      !LeadsDataHalf?.status_list?.includes(
                        "Policy Rejected"
                      )&&(
                       
                         <button
                      style={{
                        background: "linear-gradient(135deg, #f39c12, #e67e22)",
                        color: "white",
                        border: "none",
                        padding: "6px 10px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontWeight: 600,
                        cursor: "pointer",
                        transition: "0.3s",
                        // marginLeft:"5px"
                      }}
                      
                      onClick={() => handleInitiatePayment("Initiate Payment")}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.boxShadow =
                          "0 4px 10px rgba(243, 156, 18, 0.4)")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.boxShadow = "none")
                      }
                    >
                      Initiate Payment &nbsp;
                       {paymentLoading && <Spinner size="sm" />}
                    </button>
                       )}
                {/* {!LeadsDataHalf?.status_list?.includes("Proposal Form Submitted") ||
                              !LeadsDataHalf?.status_list?.includes("Payment Submitted") ||
                              !LeadsDataHalf?.status_list?.includes("Initiate Payment")&&
                        <Dropdown
                                isOpen={statusChange}
                                toggle={toggleDropdownStatus}
                              >
                                <DropdownToggle
                                  caret
                                  className="buttonOrangeDefaultColor2"
                                  size="sm"
                                >
                                  Update Status &nbsp;
                                  <i className="mdi mdi-update custom-btn-fs fs-6"></i>
                                  {(paymentLoading || proposalLoadin) && <Spinner size="sm" />}
                                </DropdownToggle>
                                <DropdownMenu>
                                 {!LeadsDataHalf?.status_list?.includes("Proposal Form Submitted")&&<DropdownItem
                                    className="dropdown-hover-item"
                                     onClick={() => handleInitiatePayment("Proposal Form")}
                                  >
                                    Proposal Form Submitted
                                  </DropdownItem>}
                              {LeadsDataHalf?.status_list?.includes("Proposal Form Submitted") &&
                              !LeadsDataHalf?.status_list?.includes("Payment Submitted") &&
                              !LeadsDataHalf?.status_list?.includes("Initiate Payment") && (
                                    <DropdownItem
                                       onClick={() => handleInitiatePayment("Initiate Payment")}
                                      className="dropdown-hover-item"
                                    >
                                      Initiate Payment
                                    </DropdownItem>
                                  )}
                                </DropdownMenu>
                              </Dropdown>
                             } */}

                {(LeadsDataHalf?.status_list?.includes(
                  "Proposal Form Submitted"
                ) ||
                  LeadsDataHalf?.status_list?.includes(
                    "Payment Submitted"
                  )) && (
                  <div style={{ display: "flex", gap: "12px" }}>
                    {/* {!LeadsDataHalf?.status_list?.includes(
                      "Payment Submitted"
                    ) &&
                      !LeadsDataHalf?.status_list?.includes(
                        "Initiate Payment"
                      ) && !LeadsDataHalf?.status_list?.includes("Policy Issued") &&
                      !LeadsDataHalf?.status_list?.includes(
                        "Policy Rejected"
                      )&&(
                       
                         <button
                      style={{
                        background: "linear-gradient(135deg, #f39c12, #e67e22)",
                        color: "white",
                        border: "none",
                        padding: "6px 10px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontWeight: 600,
                        cursor: "pointer",
                        transition: "0.3s",
                      }}
                      onClick={() => handleInitiatePayment("Initiate Payment")}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.boxShadow =
                          "0 4px 10px rgba(243, 156, 18, 0.4)")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.boxShadow = "none")
                      }
                    >
                      Initiate Payment &nbsp;
                       {paymentLoading && <Spinner size="sm" />}
                    </button>
                      )} */}

                   
                      <button
                    style={{
                      background: "linear-gradient(135deg, #2980b9, #3498db)",
                      color: "white",
                      border: "none",
                      padding: "6px 10px",
                      borderRadius: "8px",
                      fontSize: "14px",
                      fontWeight: 600,
                      cursor: "pointer",
                      transition: "0.3s",
                      marginLeft:"8px",
                      marginRight:"8px"
                    }}
                    onClick={() => handleZipDownload()}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.boxShadow =
                        "0 4px 10px rgba(41, 128, 185, 0.4)")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.boxShadow = "none")
                    }
                    
                  >
                    Download Documents {zipDownload && <Spinner size="sm" />}
                  </button>
                    {(LeadsDataHalf?.status_list?.includes(
                      "Proposal Form Submitted"
                    ) ||
                      LeadsDataHalf?.status_list?.includes(
                        "Payment Submitted"
                      )) &&
                      !LeadsDataHalf?.status_list?.includes("Policy Issued") &&
                      !LeadsDataHalf?.status_list?.includes(
                        "Policy Rejected"
                      ) && cattleDocuments?.every(
   (cattle) => 
     cattle?.documents?.some(
       (doc) =>
         doc.file_type?.toLowerCase() === "health certificate" ||
         doc.media_type === "HEALTH_CERTIFICATE"
     )
 ) && (
                       
                    <Button
                        outline
                        color="success"
                        size="sm"
                        className="p-2"
                        onClick={() => handleFarmerPolicyIssue()}
                        style={{ borderRadius: "8px"}}
                      >
                        <i className="mdi mdi-update custom-btn-fs fs-6"></i>
                        Issue Policy
                      </Button>
                      )}
                  </div>
                )}


     
























              </div>}
            </div>

            <div className="d-lg-block d-md-block d-none mt-3 mb-3">
              {showPolicy && (
                <div
                  className="border p-2 rounded shadow-sm mt-2"
                  style={{ backgroundColor: "#f3f3f3" }}
                >
                  <form onSubmit={handleAssign}>
                    <Row className="mt-3">
                      <Col lg="4">
                        <select
                          className="form-control form-control-sm"
                          style={{ minWidth: "140px" }}
                          value={policyIssueRej}
                          onChange={(e) => setPolicyIssRej(e.target.value)}
                          required
                        >
                          <option value="Policy Issued">Issue Policy</option>
                          <option value="Policy Rejected">Reject Policy</option>
                        </select>
                      </Col>
                      {policyIssueRej === "Policy Issued" ? (
                        <>
                          <Col lg="3">
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              style={{ minWidth: "120px" }}
                              placeholder="Policy ID"
                              value={policyDetails.policy_id}
                              onChange={(e) =>
                                setPolicyDetails({
                                  ...policyDetails,
                                  policy_id: e.target.value,
                                })
                              }
                              required
                            />
                          </Col>
                          <Col lg="5">
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              style={{ minWidth: "180px" }}
                              placeholder="Remarks"
                              value={remarks}
                              onChange={(e) => setRemarks(e.target.value)}
                              required
                            />
                          </Col>
                          <Col lg="4" className="mt-4">
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              style={{ minWidth: "150px" }}
                              placeholder="Policy URL"
                              value={policyDetails.policy_url}
                              onChange={(e) => {
                                const value = e.target.value;
                                setPolicyDetails({
                                  ...policyDetails,
                                  policy_url: value,
                                  file: null,
                                });
                                setPolicyUrlError(validatePolicyUrl(value));
                              }}
                              disabled={policyDetails.file !== null}
                              error={!!policyUrlError}
                              helperText={policyUrlError}
                            />
                          </Col>
                          <Col lg="4" className="mt-4 mb-2">
                            <input
                              type="file"
                              accept=".pdf"
                              className="form-control form-control-sm"
                              style={{ minWidth: "130px" }}
                              onChange={(e) => {
                                setPolicyDetails({
                                  ...policyDetails,
                                  file: e.target.files[0],
                                  policy_url: "",
                                });
                                setPolicyUrlError("");
                              }}
                              disabled={policyDetails.policy_url !== ""}
                            />
                          </Col>
                        </>
                      ) : (
                        <Col lg="8">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            style={{ minWidth: "180px" }}
                            placeholder="Remarks"
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                            required
                          />
                        </Col>
                      )}
                      <Col md="2" className="mx-3 mb-2">
                        <Button
                          id="AddLeads"
                          className="buttonGreenDefaultColor mt-4"
                          size="sm"
                          type="submit"
                        >
                          Submit &nbsp;
                          <i className="mdi mdi-account-arrow-right custom-btn-fs fs-6"></i>
                        </Button>
                      </Col>
                    </Row>
                  </form>
                </div>
              )}
              <Table className="table mb-2" hover>
                <tbody>
                  {[
                    {
                      label: "Name",
                      value: `${LeadsDataHalf?.first_name ??
                        ""} ${LeadsDataHalf?.last_name ?? ""}`,
                    },
                    { label: "Gender", value: LeadsDataHalf?.gender },
                    { label: "DOB", value: LeadsDataHalf?.DOB },
                    { label: "Age", value: LeadsDataHalf?.age },
                    { label: "Mobile", value: LeadsDataHalf?.phone_number },
                    {
                      label: "Primary Occupation",
                      value: LeadsDataHalf?.primary_occupation,
                    },
                    { label: "State", value: LeadsDataHalf?.state_name },
                    { label: "District", value: LeadsDataHalf?.district_name },
                    { label: "Block", value: LeadsDataHalf?.block_name },
                    { label: "Pincode", value: LeadsDataHalf?.pincode },
                    { label: "Address", value: LeadsDataHalf?.address },
                    { label: "Status", value: LeadsDataHalf?.current_status },
                  ]
                    .reduce((rows, item, i, arr) => {
                      if (i % 2 === 0)
                        rows.push([
                          item,
                          arr[i + 1] || { label: "", value: "" },
                        ]);
                      return rows;
                    }, [])
                    .map((row, rIdx) => (
                      <tr key={rIdx}>
                        {row.map((cell, cIdx) => (
                          <React.Fragment key={cIdx}>
                            <th
                              scope="row"
                              className="align-middle"
                              style={{ width: "20%" }}
                            >
                              {cell.label && cell.label !== "Address"
                                ? `${cell.label}:`
                                : cell.label}
                            </th>
                            <td
                              className="align-middle"
                              style={{ width: "30%" }}
                            >
                              {cell.label === "Status" ? (
                                <span
                                  style={{
                                    color: "#27ae60",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                  }}
                                >
                                  {cell.value ?? "-"}
                                </span>
                              ) : (
                                cell.value ?? "-"
                              )}
                            </td>
                          </React.Fragment>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>

            {selectedProduct?.toLowerCase() === "cattle" &&
              LeadsDataHalf?.lead_details?.[0]?.service_details?.policy_details
                ?.policy_url && (
                <div
                  className="mt-3 p-3 rounded"
                  style={{
                    border: "1px solid #eee",
                    background: "#fafafa",
                  }}
                >
                  <h6 className="fw-bold mb-3 text-primary">Policy Details</h6>
                  <div className="row">
                    <div className="col-md-6 d-flex align-items-center mb-2">
                      <div style={{ minWidth: 120 }} className="fw-semibold">
                        Policy Document:
                      </div>

                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                        onClick={() => {
                          const policyUrl =
                            LeadsDataHalf.lead_details[0]?.service_details
                              ?.policy_details?.policy_url;

                          if (
                            policyUrl &&
                            (policyUrl.startsWith("http://") ||
                              policyUrl.startsWith("https://"))
                          ) {
                            window.open(
                              policyUrl,
                              "_blank",
                              "noopener,noreferrer"
                            );
                          } else {
                            handlePolicyClick(policyUrl);
                          }
                        }}
                        title="Open policy"
                      >
                        <i
                          className="mdi mdi-download"
                          style={{ fontSize: 16 }}
                        />
                        Download / Open
                      </button>
                    </div>
                    <div className="col-md-6 d-flex align-items-center mb-2">
                      <div style={{ minWidth: 120 }} className="fw-semibold">
                        Policy No:
                      </div>
                      <span>
                        {LeadsDataHalf?.lead_details?.[0]?.service_details
                          ?.policy_details?.policy_id ?? "-"}
                      </span>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </Col>
      </Row>

      {documents?.data?.some(
        (category) =>
          category?.document_category?.toLowerCase() === "proposal form" &&
          category?.document_types?.some((docType) =>
            docType?.documents?.some(
              (doc) => doc.entity_id === LeadsDataHalf.id
            )
          )
      ) && (
        <div
          className=""
          style={{
            borderRadius: "10px",
            padding: "24px",
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.06)",
            marginBottom: "24px",
            backgroundColor: "white",
            border: "1px solid #f0f0f0",
          }}
        >
          <h6
            style={{
              fontWeight: "600",
              marginBottom: "16px",
              color: "#333",
            }}
          >
            Proposal Form
          </h6>

          <div className="d-flex gap-2 flex-wrap">
            {documents?.data?.flatMap((category) =>
              category?.document_category?.toLowerCase() === "proposal form"
                ? category?.document_types?.flatMap((docType) =>
                    docType?.documents
                      ?.filter((doc) => doc.entity_id === LeadsDataHalf.id)
                      ?.map((doc) => (
                        <div
                          key={doc.id}
                          className="text-center"
                          style={{
                            width: 120,
                            cursor: "pointer",
                            flexShrink: 0,
                          }}
                          onClick={() => {
                            handleDocClick(doc);
                          }}
                        >
                          <div
                            style={{
                              border: "1px solid #ddd",
                              borderRadius: 6,
                              padding: 4,
                              background: "#fff",
                              transition: "all 0.2s ease-in-out",
                            }}
                            className="hover-shadow"
                          >
                            <img
                              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSITKmWTrarr0VI2iJrXYZBRO0rA9IE8Tj7jg&s"
                              alt={convertToTitleCase(doc?.media_type)}
                              width="100"
                              height="60"
                              style={{
                                objectFit: "cover",
                                borderRadius: 4,
                                display: "block",
                                margin: "0 auto",
                              }}
                            />
                          </div>

                          <div
                            style={{
                              marginTop: 6,
                              fontSize: 13,
                              fontWeight: 500,
                              color: "#444",
                              textAlign: "center",
                              wordBreak: "break-word",
                            }}
                            title={convertToTitleCase(doc?.media_type)}
                          >
                            {convertToTitleCase(doc?.media_type)}
                          </div>
                        </div>
                      ))
                  )
                : []
            )}
          </div>
        </div>
      )}

      {documents?.data?.some(
        (category) =>
          category?.document_category?.toLowerCase() === "kyc documents" &&
          category?.document_types?.some(
            (docType) => docType?.documents?.length > 0
          )
      ) && (
        <div
          className=""
          style={{
            borderRadius: "10px",
            padding: "24px",
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.06)",
            marginBottom: "24px",
            backgroundColor: "white",
            border: "1px solid #f0f0f0",
          }}
        >
          <h6
            style={{
              fontWeight: "600",
              marginBottom: "16px",
              color: "#333",
            }}
          >
            KYC Documents
          </h6>

          <div className="d-flex gap-2 flex-wrap">
            {documents?.data?.flatMap((category) =>
              category?.document_types?.flatMap((docType) =>
                docType?.documents?.map((doc) =>
                  category.document_category.toLowerCase() ===
                  "kyc documents" ? (
                    // <div
                    //   key={doc.id}
                    //   className="d-flex align-items-center p-2"
                    //   style={{
                    //     border: "1px solid #eee",
                    //     borderRadius: "6px",
                    //     background: "#fff",
                    //     gap: "10px",
                    //     cursor: "pointer",
                    //     transition: "all 0.2s ease-in-out",
                    //   }}
                    //   onMouseOver={(e) =>
                    //     (e.currentTarget.style.background = "#f8f9fa")
                    //   }
                    //   onMouseOut={(e) =>
                    //     (e.currentTarget.style.background = "#fff")
                    //   }
                    //   onClick={() => handleDocClick(doc)}
                    // >
                    //   <img
                    //     src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSITKmWTrarr0VI2iJrXYZBRO0rA9IE8Tj7jg&s"
                    //     width="50"
                    //     height="35"
                    //     style={{
                    //       borderRadius: "4px",
                    //       objectFit: "cover",
                    //       flexShrink: 0,
                    //     }}
                    //     alt="KYC Document"
                    //   />
                    //   <span
                    //     style={{
                    //       fontSize: "14px",
                    //       fontWeight: "500",
                    //       color: "#555",
                    //     }}
                    //   >
                    //     {convertToTitleCase(doc?.media_type)}
                    //   </span>
                    // </div>
                    <div
                      key={doc.id}
                      className="text-center"
                      style={{
                        width: 120,
                        cursor: "pointer",
                        flexShrink: 0,
                      }}
                      onClick={() => {
                        handleDocClick(doc);
                      }}
                    >
                      <div
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: 6,
                          padding: 4,
                          background: "#fff",
                          transition: "all 0.2s ease-in-out",
                        }}
                        className="hover-shadow"
                      >
                        <img
                          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSITKmWTrarr0VI2iJrXYZBRO0rA9IE8Tj7jg&s"
                          alt={convertToTitleCase(doc?.media_type)}
                          width="100"
                          height="60"
                          style={{
                            objectFit: "cover",
                            borderRadius: 4,
                            display: "block",
                            margin: "0 auto",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          marginTop: 6,
                          fontSize: 13,
                          fontWeight: 500,
                          color: "#444",
                          textAlign: "center",
                          wordBreak: "break-word",
                        }}
                        title={convertToTitleCase(doc?.media_type)}
                      >
                        {convertToTitleCase(doc?.media_type)}
                      </div>
                    </div>
                  ) : null
                )
              )
            )}
          </div>
        </div>
      )}

      {selectedProduct?.toLowerCase() === "cattle" ? (
        <div style={{ marginTop: 8 }}>
          <div
            style={{
              borderRadius: 10,
              padding: 24,
              boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
              marginBottom: 24,
              backgroundColor: "white",
              border: "1px solid #f0f0f0",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #ddd",
                paddingBottom: 6,
              }}
            >
              <h6 style={{ fontWeight: 500, margin: 0 }}>
                {selectedProduct} DETAILS
              </h6>
              <span
                style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#0d6efd",
                  background: "#e9f2ff",
                  padding: "4px 10px",
                  borderRadius: 20,
                }}
              >
                🐄 {cattleDocuments?.length || 0} Cattle
              </span>
            </div>

            {/* {cattleDocuments?.length > 0 ? (
              cattleDocuments.map((cattle) => (
                <div key={cattle.cattle_id} className="mb-3 mt-3">
                  <h6 className="fw-bold text-dark mb-3">
                    Cattle Tag No. : {cattle.cattle_tag_number}
                  </h6>

                  <div className="d-flex flex-wrap gap-3">
                    {cattle.documents?.length > 0 ? (
                      cattle.documents.map((doc) => (
                        <div
                          key={doc.id}
                          className="text-center"
                          style={{
                            width: 120,
                            cursor: "pointer",
                            flexShrink: 0,
                          }}
                          onClick={() => {
                            handleDocClick(doc);
                          }}
                        >
                          <div
                            style={{
                              border: "1px solid #ddd",
                              borderRadius: 6,
                              padding: 4,
                              background: "#fff",
                              transition: "all 0.2s ease-in-out",
                            }}
                            className="hover-shadow"
                          >
                            <img
                              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSITKmWTrarr0VI2iJrXYZBRO0rA9IE8Tj7jg&s"
                              alt={convertToTitleCase(doc?.media_type)}
                              width="100"
                              height="60"
                              style={{
                                objectFit: "cover",
                                borderRadius: 4,
                                display: "block",
                                margin: "0 auto",
                              }}
                            />
                          </div>

                          <div
                            style={{
                              marginTop: 6,
                              fontSize: 13,
                              fontWeight: 500,
                              color: "#444",
                              textAlign: "center",
                              wordBreak: "break-word",
                            }}
                            title={convertToTitleCase(doc?.media_type)}
                          >
                            {convertToTitleCase(doc?.media_type)}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div
                        className="text-muted"
                        style={{ padding: "12px 8px" }}
                      >
                        No documents available
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="text-muted" style={{ padding: 12 }}>
                No cattle records found
              </div>
            )} */}
            {/* {console.log("cattleDocuments",cattleDocuments)} */}
            <div>
              {cattleDocuments?.length > 0 ? (
                cattleDocuments.map((cattle) => (
                  <div key={cattle.cattle_id} className="mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
                       <h6 className="mb-0">
                        Cattle ID. :{" "}
                        <span className="text-dark fw-bold">
                          {cattle?.cattle_id}
                        </span>
                      </h6>
                      <h6 className="mb-0">
                        Cattle Tag No. :{" "}
                        <span className="text-dark fw-bold">
                          {cattle?.cattle_tag_number?.toUpperCase()}
                        </span>
                      </h6>
                      
                       <h6 className="mb-0">
                        Cattle Tag Date :{" "}
                        <span className="text-dark fw-bold">
                          {cattle?.cattle_tag_date}
                        </span>
                      </h6>
                      {/* {(cattle.documents?.length > 0 
                      ||
                        cattle.cattle_health_certificate
                      )
                         &&
                        !cattle?.policy_details &&
                        !LeadsDataHalf?.lead_details?.[0]?.service_details
                          ?.policy_details?.policy_url && (
                        
                            <Button
                        outline
                        color="success"
                        size="sm"
                        className="mt-2"
                        onClick={() => togglePolicyForm(cattle.cattle_id)}
                      >
                        <i className="mdi mdi-update custom-btn-fs fs-6"></i>
                        Issue Policy
                      </Button>
                        )} */}



                        {cattle?.documents?.length > 0 && (LeadsDataHalf?.status_list?.includes("Proposal Form Submitted")|| LeadsDataHalf?.status_list?.includes("Payment Submitted")) && (
  <>
  {/* {console.log("cattle",cattle)} */}
    {cattle?.policy_details ? (
      <div
    className="d-flex align-items-center mt-2"
    style={{
      fontWeight: "600",
      color:
        cattle?.policy_details?.current_status === "Policy Rejected"
          ? "#dc2626" 
          : "#16a34a",
      fontSize: "15px",
      gap: "6px",
    }}
  >
    {cattle?.policy_details?.current_status === "Policy Rejected" ? (
      <i className="mdi mdi-close-circle-outline fs-5"></i>
    ) : (
      <i className="mdi mdi-check-circle-outline fs-5"></i>
    )}
    <span>{cattle?.policy_details?.current_status}</span>
  </div>
    ) : (
       !cattle?.policy_details &&
                        !LeadsDataHalf?.lead_details?.[0]?.service_details
                          // ?.policy_details?.policy_url && cattle?.documents?.some(
                           ?.policy_details && cattle?.documents?.some(

        (doc) =>
          doc?.file_type?.toLowerCase() === "health certificate" ||
          doc?.media_type === "HEALTH_CERTIFICATE"
      ) ?  (
        <Button
          outline
          color="success"
          size="sm"
          className="mt-2"
          onClick={() => togglePolicyForm(cattle.cattle_id)}
        >
          <i className="mdi mdi-update custom-btn-fs fs-6"></i>
          Issue Policy
        </Button>
      )
      :LeadsDataHalf?.current_status==="Policy Rejected" || LeadsDataHalf?.current_status==="Policy Issued"?
         <div
    className="d-flex align-items-center mt-2"
    style={{
      fontWeight: "600",
      color:
        LeadsDataHalf?.current_status === "Policy Rejected"
          ? "#dc2626" 
          : "#16a34a",
      fontSize: "15px",
      gap: "6px",
    }}
  >
    {LeadsDataHalf?.current_status === "Policy Rejected" ? (
      <i className="mdi mdi-close-circle-outline fs-5"></i>
    ) : (
      <i className="mdi mdi-check-circle-outline fs-5"></i>
    )}
    <span>{LeadsDataHalf?.current_status}</span>
  </div>
  :""
    )}
  </>
)}

                    </div>

                    <div className="d-flex flex-wrap gap-3">
                      {cattle.documents?.length > 0 ||
                      cattle.policy_details 
                      // ||
                      // cattle.cattle_health_certificate 
                      ? (
                        <div
                          style={{
                            display: "flex",
                            gap: "12px",
                            flexWrap: "wrap",
                          }}
                        >
                          {cattle.documents?.map((doc) => (
                            <div
                              key={doc.id}
                              className="text-center"
                              style={{
                                width: 120,
                                cursor: "pointer",
                                flexShrink: 0,
                              }}
                              onClick={() => handleDocClick(doc)}
                            >
                              <div
                                style={{
                                  border: "1px solid #ddd",
                                  borderRadius: 6,
                                  padding: 4,
                                  background: "#fff",
                                  transition: "all 0.2s ease-in-out",
                                }}
                                className="hover-shadow"
                              >
                                <img
                                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSITKmWTrarr0VI2iJrXYZBRO0rA9IE8Tj7jg&s"
                                  alt={convertToTitleCase(doc?.media_type)}
                                  width="100"
                                  height="60"
                                  style={{
                                    objectFit: "cover",
                                    borderRadius: 4,
                                    display: "block",
                                    margin: "0 auto",
                                  }}
                                />
                              </div>

                              <div
                                style={{
                                  marginTop: 6,
                                  fontSize: 13,
                                  fontWeight: 500,
                                  color: "#444",
                                  textAlign: "center",
                                  wordBreak: "break-word",
                                }}
                                title={convertToTitleCase(doc?.media_type)}
                              >
                                {convertToTitleCase(doc?.media_type)}
                              </div>
                            </div>
                          ))}

                          {cattle?.policy_details?.policy_url && (
                            <div
                              className="text-center"
                              style={{
                                width: 120,
                                cursor: "pointer",
                                flexShrink: 0,
                              }}
                              onClick={() => {
                                if (
                                  cattle.policy_details.policy_url.startsWith(
                                    "http://"
                                  ) ||
                                  cattle.policy_details.policy_url.startsWith(
                                    "https://"
                                  )
                                ) {
                                  window.open(
                                    cattle.policy_details.policy_url,
                                    "_blank",
                                    "noopener,noreferrer"
                                  );
                                } else {
                                  handlePolicyClick(
                                    cattle.policy_details.policy_url
                                  );
                                }
                              }}
                            >
                              <div
                                style={{
                                  border: "1px solid #ddd",
                                  borderRadius: 6,
                                  padding: 4,
                                  background: "#fff",
                                  transition: "all 0.2s ease-in-out",
                                }}
                                className="hover-shadow"
                              >
                                <img
                                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSITKmWTrarr0VI2iJrXYZBRO0rA9IE8Tj7jg&s"
                                  alt="Policy Document"
                                  width="100"
                                  height="60"
                                  style={{
                                    objectFit: "cover",
                                    borderRadius: 4,
                                    display: "block",
                                    margin: "0 auto",
                                  }}
                                />
                              </div>

                              <div
                                style={{
                                  marginTop: 6,
                                  fontSize: 13,
                                  fontWeight: 500,
                                  color: "#444",
                                  textAlign: "center",
                                  wordBreak: "break-word",
                                }}
                                title="Policy Document"
                              >
                                Policy Document
                              </div>
                            </div>
                          )}
                          {/* {cattle?.cattle_health_certificate && (
                            <div
                              className="text-center"
                              style={{
                                width: 120,
                                cursor: "pointer",
                                flexShrink: 0,
                              }}
                              onClick={() => {
                                if (
                                  cattle.cattle_health_certificate.startsWith(
                                    "http://"
                                  ) ||
                                  cattle.cattle_health_certificate.startsWith(
                                    "https://"
                                  )
                                ) {
                                  window.open(
                                    cattle.cattle_health_certificate,
                                    "_blank",
                                    "noopener,noreferrer"
                                  );
                                } else {
                                  handleDocClick(
                                    cattle.cattle_health_certificate
                                  );
                                }
                              }}
                            >
                              <div
                                style={{
                                  border: "1px solid #ddd",
                                  borderRadius: 6,
                                  padding: 4,
                                  background: "#fff",
                                  transition: "all 0.2s ease-in-out",
                                }}
                                className="hover-shadow"
                              >
                                <img
                                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSITKmWTrarr0VI2iJrXYZBRO0rA9IE8Tj7jg&s"
                                  alt="Policy Document"
                                  width="100"
                                  height="60"
                                  style={{
                                    objectFit: "cover",
                                    borderRadius: 4,
                                    display: "block",
                                    margin: "0 auto",
                                  }}
                                />
                              </div>

                              <div
                                style={{
                                  marginTop: 6,
                                  fontSize: 13,
                                  fontWeight: 500,
                                  color: "#444",
                                  textAlign: "center",
                                  wordBreak: "break-word",
                                }}
                                title="Policy Document"
                              >
                                Health Certificate
                              </div>
                            </div>
                          )} */}
                        </div>
                      ) : (
                        <div className="text-muted" style={{ padding: 12 }}>
                          No cattle records found
                        </div>
                      )}
                    </div>

                    {policyForms[cattle.cattle_id] && (
                      <div
                        className="border p-2 rounded shadow-sm mt-2"
                        style={{ backgroundColor: "#f3f3f3" }}
                      >
                        <div className="d-flex gap-2 mb-2 align-items-center ">
                          <select
                            className="form-control form-control-sm"
                            style={{ minWidth: "140px" }}
                            value={
                              policyForms[cattle.cattle_id]?.action || "Issued"
                            }
                            onChange={(e) =>
                              handlePolicyChange(
                                cattle.cattle_id,
                                "action",
                                e.target.value
                              )
                            }
                            required
                          >
                            <option value="Issued">Issue Policy</option>
                            <option value="Rejected">Reject Policy</option>
                          </select>
                          {(policyForms[cattle.cattle_id]?.action ||
                            "Issued") === "Issued" && (
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              style={{ minWidth: "120px" }}
                              placeholder="Policy ID"
                              value={
                                policyForms[cattle.cattle_id]?.policy_id || ""
                              }
                              onChange={(e) =>
                                handlePolicyChange(
                                  cattle.cattle_id,
                                  "policy_id",
                                  e.target.value
                                )
                              }
                              required
                            />
                          )}
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            style={{ minWidth: "180px" }}
                            placeholder="Remarks"
                            value={policyForms[cattle.cattle_id]?.remarks || ""}
                            onChange={(e) =>
                              handlePolicyChange(
                                cattle.cattle_id,
                                "remarks",
                                e.target.value
                              )
                            }
                            required
                          />
                        </div>
                        <div className="d-flex gap-2 align-items-center">
                          {(policyForms[cattle.cattle_id]?.action ||
                            "Issued") === "Issued" && (
                            <>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                style={{ minWidth: "150px" }}
                                placeholder="Policy URL"
                                value={
                                  policyForms[cattle.cattle_id]?.policy_url ||
                                  ""
                                }
                                onChange={(e) =>
                                  handlePolicyChange(
                                    cattle.cattle_id,
                                    "policy_url",
                                    e.target.value
                                  )
                                }
                                disabled={
                                  policyForms[cattle.cattle_id]?.policy_file
                                }
                                required={
                                  !policyForms[cattle.cattle_id]?.policy_file
                                }
                              />

                              <input
                                type="file"
                                accept=".pdf"
                                className="form-control form-control-sm"
                                style={{ minWidth: "130px" }}
                                onChange={(e) =>
                                  handlePolicyChange(
                                    cattle.cattle_id,
                                    "policy_file",
                                    e.target.files[0]
                                  )
                                }
                                disabled={
                                  policyForms[cattle.cattle_id]?.policy_url
                                }
                                required={
                                  !policyForms[cattle.cattle_id]?.policy_url
                                }
                              />
                            </>
                          )}

                          <Button
                            id="AddLeads"
                            className="buttonGreenDefaultColor mt-3 px-4 shadow-sm mb-2"
                            onClick={() => submitPolicy(cattle.cattle_id)}
                            size="sm"
                          >
                            Submit{" "}
                            {issueLoading[cattle.cattle_id] && (
                              <Spinner size="sm" />
                            )}
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <div className="text-muted" style={{ padding: 12 }}>
                  No cattle records found
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div
          className="row"
          style={{
            borderRadius: 10,
            padding: 24,
            boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
            marginBottom: 24,
            backgroundColor: "white",
          }}
        >
          <h6
            style={{
              borderBottom: "1px solid #ddd",
              paddingBottom: 6,
              fontWeight: 500,
            }}
          >
            {selectedProduct} DETAILS
          </h6>
          {renderServiceDetailsGrid()}
        </div>
      )}

      {documents?.data?.some(
        (category) =>
          category?.document_category?.toLowerCase() === "payment detail" &&
          category?.document_types?.some((docType) =>
            docType?.documents?.some(
              (doc) => doc.entity_id === LeadsDataHalf.id
            )
          )
      ) && (
        <div
          className=""
          style={{
            borderRadius: "10px",
            padding: "24px",
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.06)",
            marginBottom: "24px",
            backgroundColor: "white",
            border: "1px solid #f0f0f0",
          }}
        >
          <h6
            style={{
              fontWeight: "600",
              marginBottom: "16px",
              color: "#333",
            }}
          >
            Payment Details
          </h6>
          {documents?.data?.some(
            (category) =>
              category?.document_category?.toLowerCase() === "payment detail" &&
              category?.document_types?.some((docType) =>
                docType?.documents?.some(
                  (doc) => doc.entity_id === LeadsDataHalf.id
                )
              )
          ) && (
            <div className="row align-items-center mb-3">
              <div className="col-4">
                <label className="form-label">Amount</label>
                <input
                  type="text"
                  className="form-control"
                  value={LeadsDataHalf?.cattle_ins_gen_form?.amount || ""}
                  disabled
                />
              </div>

              <div className="col-4">
                <label className="form-label">Payment ID</label>
                <input
                  type="text"
                  className="form-control"
                  value={LeadsDataHalf?.cattle_ins_gen_form?.paymentId || ""}
                  disabled
                />
              </div>

              <div className="col-4">
                <label className="form-label">Remark</label>
                <input
                  type="text"
                  className="form-control"
                  value={LeadsDataHalf?.cattle_ins_gen_form?.remark || ""}
                  disabled
                />
              </div>
            </div>
          )}
          <div className="d-flex gap-2 flex-wrap">
            {documents?.data?.flatMap((category) =>
              category?.document_category?.toLowerCase() === "payment detail"
                ? category?.document_types?.flatMap((docType) =>
                    docType?.documents
                      ?.filter((doc) => doc.entity_id === LeadsDataHalf.id)
                      ?.map((doc) => (
                        <div
                          key={doc.id}
                          className="text-center"
                          style={{
                            width: 120,
                            cursor: "pointer",
                            flexShrink: 0,
                          }}
                          onClick={() => {
                            handleDocClick(doc);
                          }}
                        >
                          <div
                            style={{
                              border: "1px solid #ddd",
                              borderRadius: 6,
                              padding: 4,
                              background: "#fff",
                              transition: "all 0.2s ease-in-out",
                            }}
                            className="hover-shadow"
                          >
                            <img
                              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSITKmWTrarr0VI2iJrXYZBRO0rA9IE8Tj7jg&s"
                              alt={convertToTitleCase(doc?.media_type)}
                              width="100"
                              height="60"
                              style={{
                                objectFit: "cover",
                                borderRadius: 4,
                                display: "block",
                                margin: "0 auto",
                              }}
                            />
                          </div>

                          <div
                            style={{
                              marginTop: 6,
                              fontSize: 13,
                              fontWeight: 500,
                              color: "#444",
                              textAlign: "center",
                              wordBreak: "break-word",
                            }}
                            title={convertToTitleCase(doc?.media_type)}
                          >
                            {convertToTitleCase(doc?.media_type)}
                          </div>
                        </div>
                      ))
                  )
                : []
            )}
          </div>
        </div>
      )}

      {openLightbox && mediaType === "image" && (
        <Lightbox
          image={lightBoxViewImage}
          title="Image Preview"
          onClose={() => {
            setOpenLightBox(false);
          }}
        />
      )}

      {overlayOpen && mediaType === "mp4" && (
        <div
          className="media-overlay d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.7)",
            zIndex: 2000,
            padding: 20,
          }}
        >
          <div
            style={{
              position: "relative",
              width: "95%",
              maxWidth: 1300,
              height: "90vh",
              background: "#fff",
              borderRadius: 8,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px 12px",
                borderBottom: "1px solid #eee",
              }}
            >
              <div style={{ fontWeight: 600 }}>Video Preview</div>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <Button
                  size="sm"
                  color="danger"
                  onClick={() => {
                    setOverlayOpen(false);
                  }}
                >
                  Close
                </Button>
              </div>
            </div>

            <div style={{ flex: 1, minHeight: 0 }}>
              <video
                src={overlayUrl}
                controls
                autoPlay
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  background: "#000",
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
